<div class="menu_container">
  <perfect-scrollbar>

    <div class="menu-left">

      <div class="profile-container">
        <img  src="assets/img/ramadan2022/ramadan-logo.png" style="width: 50px" class="img-fluid" routerLink="home">

      </div>
      <div class="header-content" *ngIf="!mobview" >

        <a class="item" routerLink="home" routerLinkActive="active">
          <p>الرئيسية</p>
        </a>
        <a class="item" routerLink="tournaments" routerLinkActive="active">
          <p>البطولات</p>
        </a>
        <a class="item " routerLink="players" routerLinkActive="active" >
          <p>اللاعبين</p>
        </a>
          </div>
      <div class="ml-2 d-flex " *ngIf="mobview">
        <div class="mobile-menu-category-container desktop-none">
          <!--           [ngClass]="{'active':opened}"-->
          <a class="item menubar desktop-none" (click)="toggle()">
            <svg-icon name="menubar"></svg-icon>
          </a>
        </div>
      </div>
    </div>


    <mat-drawer-container class=" app-container" autosize>
      <mat-drawer #drawer [mode]="'over'" [opened]="opened" (closed)="opened = false" position="end">
        <div class="drawerCon">
          <div id="sidemenu-wrapper">

              <img  src="assets/img/ramadan2022/ramadan-logo.png" style="width: 50px" class="img-fluid" routerLink="/">
            <a class="item" routerLink="home" routerLinkActive="active" (click)="navigateTo()">
              <p>الرئيسية</p>
            </a>
            <a class="item" routerLink="tournaments" routerLinkActive="active" (click)="navigateTo()">
              <p>البطولات</p>
            </a>
            <a class="item " routerLink="players" routerLinkActive="active" (click)="navigateTo()">
              <p>اللاعبين</p>
            </a>

          </div>

        </div>


      </mat-drawer>
    </mat-drawer-container>
  </perfect-scrollbar>

</div>
